import type { CreanceRow } from "@/lib/creance.api";

export function parseAmount(value: string): number {
  return parseFloat(value);
}

export function formatMoney(value: number): string {
  return `${value.toLocaleString("fr-FR")} XAF`;
}

export function formatDate(value: string): string {
  return new Date(value).toLocaleDateString("fr-FR");
}

export function getCreanceInvoiceLabel(row: CreanceRow): string {
  return row.invoiceNumber ?? `Facture #${row.invoiceId}`;
}
